import React from 'react';
import styled from "styled-components"
import GIF from '../Assets/Home.mov'


const VideoContainer = styled.div`
    width: 100%;
    
    video{
        width: 100%;
        height: auto;
    }

    @media (max-width: 64em) {
        min-width: 40vh
    }
`

const CoverVideo = () => {
    return (
        <VideoContainer>
            <video src={GIF} type="video/mov" autoPlay muted loop />
        </VideoContainer>
    )
}

export default CoverVideo;